import { userConstants } from './constantData';

export const MY_PAGE_DATA = {
  lander: {
    page_view: {
      hash: 'p-072.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
};
